export default (input: string, amount = Infinity): string => input + (amount === 1 ? '' : 's');
